import React, { Component } from "react";
// import { Container } from "semantic-ui-react";

class LinkedInBadge extends Component {
  // <LinkedInBadge /* linkedInHandle='vivekpothina' *//>
  state = {
    responsiveCount: 4
  };

  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://platform.linkedin.com/badges/js/profile.js";
    script.async = true;
    script.defer = true;
    script.type = "text/javascript";
    document.body.appendChild(script);
    if (window.innerWidth / 100 < 5) {
      this.setState({ responsiveCount: 1 });
    } else if (window.innerWidth / 100 < 8) {
      this.setState({ responsiveCount: 3 });
    } else {
      this.setState({ responsiveCount: 4 });
    }
  }

  renderBadge = handle => {
    if (this.state.responsiveCount >= 3) {
      return (
        <div
          className="LI-profile-badge"
          data-version="v1"
          data-size="medium"
          data-locale="en_US"
          data-type="vertical"
          data-theme="dark"
          data-vanity={handle}
        />
      );
    } else {
      return (
        <div
          class="LI-profile-badge"
          data-version="v1"
          data-size="medium"
          data-locale="en_US"
          data-type="horizontal"
          data-theme="dark"
          data-vanity={handle}
        />
      );
    }
  };

  render() {
    let handle = this.props.linkedInHandle;
    // console.log(this.props.linkedInHandle)
    if (
      this.props.linkedInHandle === "" ||
      this.props.linkedInHandle === undefined
    ) {
      handle = "";
    }
    return (
      // <Container>
      this.renderBadge(handle)
      /*  */
      // </Container>
    );
  }
}

export default LinkedInBadge;
